import React, { useEffect, useState } from "react";
import { Box, Link, makeStyles } from "@material-ui/core";
import DefaultInput from "../../../components/Input/Default";
import DefaultButton from "../../../components/Button/Default";
import { PANCAKE_LP_USDT_STM, TOKEN_ABI,STAKE_ABI,getWeb3, STAKE_STM_USDT_LP,lpDecimals,rewardDecimals } from "../web/util";
import { toast,ToastContainer } from "react-toastify";
import Web3 from 'web3';

const useStyles = makeStyles((theme) => ({
  maxInput: {
    float: "right",
  }
}));

const LiquidityStakingContainer = () => {

  const classes = useStyles();
  const [lpBalance, setLPBalance] = useState(0);
  const [stakedLPBalance, setStakedLPBalance] = useState(0);
  const [rewards, setRewards] = useState(0);
  const [stakeInput, setStakeInput] = useState(0);
  const [unstakeInput, setUnstakeInput] = useState(0);
  const [publicAddress, setPublicAddress] = useState("");
  let curWeb = getWeb3();
  if(!window.web3Con){
    let web3Con = new Web3(curWeb);
    window.web3Con = web3Con;
  }
  let LPContract = new window.web3Con.eth.Contract(TOKEN_ABI, PANCAKE_LP_USDT_STM);
  let StakeContract = new window.web3Con.eth.Contract(STAKE_ABI, STAKE_STM_USDT_LP);
  const initBalance = async () => {
    //console.log("INIT",curWeb);
    if (curWeb) {
      let accounts = await window.web3Con.eth.getAccounts();
      if(accounts.length){
        let curAddr = accounts[0];
        setPublicAddress(curAddr);
        let LP = await LPContract.methods.balanceOf(curAddr).call();
        setLPBalance(LP/ Math.pow(10, (lpDecimals-6)));
      }
    }
  };

  const getStakedLPBalance = async () => {
    //console.log("INIT",curWeb);
    if (curWeb) {
      let accounts = await window.web3Con.eth.getAccounts();
      let curAddr = accounts[0];
      setPublicAddress(curAddr);
      let StakedLP = await StakeContract.methods.balanceOf(curAddr).call();
      setStakedLPBalance(StakedLP/ Math.pow(10, (lpDecimals-6)));
    }
  };

  const getRewardsNum = async () => {
    //console.log("INIT",curWeb);
    if (curWeb) {
      let accounts = await window.web3Con.eth.getAccounts();
      let curAddr = accounts[0];
      setPublicAddress(curAddr);
      let rewards = await StakeContract.methods.earned(curAddr).call();
      setRewards(rewards/ Math.pow(10, rewardDecimals));
    }
  };

  const approve = async () => {
    try {
      let allowance = await  LPContract.methods.allowance(publicAddress,STAKE_STM_USDT_LP).call();
      let allowanceBN = window.web3Con.utils.toWei(allowance,'wei');
      let enoughAllowance = window.web3Con.utils.toWei('100');
      if(window.web3Con.utils.toBN(allowanceBN).lt(window.web3Con.utils.toBN(enoughAllowance))){
        await LPContract.methods.approve(STAKE_STM_USDT_LP, '115792089237316195423570985008687907853269984665640564039457584007913129639935').send({ from: publicAddress});
        toast.success('approve success,click stake to continue.');
      }
    } catch (error) {
      // console.log(error);
      toast.warn(error);
    }
  }

  const stake = async () => {
    //e.preventDefault();
    try {
      await approve();
      if (stakeInput <= lpBalance) {
        let value = window.web3Con.utils.toWei(stakeInput.toString(),'micro');
        let result = await StakeContract.methods.stake(value).send({ from: publicAddress});
        toast.success(result.blockHash);
        setStakeInput(0)
      } else {
        alert("Stake input needs to be less than your total LP balance!")
      }
    } catch (error) {
      // console.log(error);
      toast.warn(error);
    }
  }
  const unstake = async () => {
    //e.preventDefault();
    try {
      if (unstakeInput <= stakedLPBalance) {
        let value = window.web3Con.utils.toWei(unstakeInput.toString(),'micro');
        let result = await StakeContract.methods.withdraw(value).send({ from: publicAddress});
        toast.success(result.blockHash);
        setUnstakeInput(0);
      } else {
        alert("Unstake input needs to be less than your total staked LP balance!")
      }
    } catch (error) {
      // console.log(error);
      toast.warn(error);
    }
  }
  const getReward = async () => {
    //e.preventDefault();
    try {

      let result = await StakeContract.methods.getReward().send({ from: publicAddress});
      toast.success(result.blockHash);
    } catch (error) {
      // console.log(error);
      toast.warn(error);
    }
  }
  const maxStake = () => {
    setStakeInput(lpBalance);
  }

  const maxUnstake = () => {
    setUnstakeInput(stakedLPBalance);
  }

  useEffect(() => {
    var interval = setInterval(() => {
      initBalance();
      getStakedLPBalance();
      getRewardsNum();
    },2000)
    return () => clearInterval(interval)
  }, [curWeb])

  return (
    <Box id="stakingb1ls2" className="in active">
    <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
    />
    <ToastContainer />

      <Box className="table-wrp">
        <Box className="Textfield-wrp LPT-wrp">
          <h6>{lpBalance} &nbsp;BSC-USD-STM</h6>
          <ul>
            <DefaultInput
              id="stakeInput"
              label="Stake"
              value={stakeInput}
              onChange={(e) => setStakeInput(e.target.valueAsNumber)}
              type="number"
            />

            <li>
              {/* <h6 className={classes.maxInput}> <span>{lpBalance}</span></h6> */}
              <Link href="#!" onClick={maxStake}>
                <h4 className={classes.maxInput}>MAX</h4>
              </Link>
            </li>
          </ul>
          <DefaultButton type="button" label="Stake" onClick={stake}></DefaultButton>
          <Box className="clear"></Box>
        </Box>
        <Box className="Textfield-wrp LPT-wrp">
          <h6>Staked: {stakedLPBalance}</h6>
          <ul>
            <DefaultInput id="unstakeInput"
            value={unstakeInput}
            onChange={(e) => setUnstakeInput(e.target.value)}
            label="Unstake"
            type="number"
            ></DefaultInput>
            <li>
              {/* <h5 className={classes.maxInput}>{stakedLPBalance}</h5> */}
              <Link href="#!" onClick={maxUnstake}>
                <h4 className={classes.maxInput}>MAX</h4>
              </Link>
            </li>
          </ul>
          <DefaultButton onClick={unstake} label="Unstake"></DefaultButton>
          <Box className="clear"></Box>
        </Box>
        <Box className="Textfield-wrp LPT-wrp">
          <h6>Rewards: {rewards}</h6>
          <DefaultButton label="GetRewards" onClick={getReward}></DefaultButton>
          <Box className="clear"></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LiquidityStakingContainer;
